import { I4goFrameDialogService } from './I4goFrameDialogForm';

var I4goIframeDialogMembershipBillingInformation = {

    i4goFrameDialogService: null,

    init: function() {
        this.i4goFrameDialogService = new I4goFrameDialogService();
    },

    openDialog: function(userId, i4goIframeDialogOptions, callback) {
        this.init();
        this.i4goFrameDialogService.open(
            function(form, data) {
                callback(data);
            },
            {
                dialogOptions: {
                    title: '<b>Enter Credit/Debit Card to store on file</b>',
                    caProUI: true,
                    staticForm: false,
                },
                i4goIframeDialogOptions: i4goIframeDialogOptions
            }
        );
    },
};

export default I4goIframeDialogMembershipBillingInformation;
